import { useCallback, useState } from 'react'
import { useTheme } from '@mui/material/styles'

export function useHandlers() {
  const [tabIndex, setTabIndex] = useState(0)
  const theme = useTheme()
  const setColor = useCallback(
    (index: number, length: number) =>
      !length
        ? 'rgba(0, 0, 0, .38)!important'
        : index === tabIndex
        ? '#19305A'
        : theme.palette.text.secondary,
    [tabIndex],
  )

  const handleTabChange = useCallback(
    (_, newTabIndex: number) => setTabIndex(newTabIndex),
    [],
  )

  return {
    tabIndex,
    setColor,
    setTabIndex,
    handleTabChange,
  }
}
